module.exports = __webpack_public_path__ + "static/media/laborleiter_tuer_ohne_markierung.228b9157.jpg";